module.exports = __webpack_public_path__ + "img/亚银不干胶标签.eb3b07ba.jpg";